import { motion } from "framer-motion";
import { Phone, Mail, MapPin, Clock } from "lucide-react";

const ITEMS = [
  {
    icon: Phone,
    label: "Telefon",
    value: "0176 41162064",
    href: "tel:+4917641162064",
    testId: "contact-phone-link",
  },
  {
    icon: Mail,
    label: "E-Mail",
    value: "LLP.service@web.de",
    href: "mailto:LLP.service@web.de",
    testId: "contact-email-link",
  },
  {
    icon: MapPin,
    label: "Adresse",
    value: "Hummelbecker Str. 18, 32429 Minden",
    testId: "contact-address",
  },
  {
    icon: Clock,
    label: "Erreichbarkeit",
    value: "Mo–Fr 7–18 Uhr · Sa n. Vereinbarung",
    testId: "contact-hours",
  },
];

export default function ContactSection() {
  return (
    <section id="kontakt" className="py-16 sm:py-24 lg:py-32 px-4 sm:px-8 lg:px-16 bg-[#141614]" data-testid="contact-section">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
        >
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#C89D66]">Kontakt</p>
          <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight mt-4 text-white">
            Sprechen Sie uns an – wir freuen uns auf Ihr Projekt
          </h2>
          <p className="mt-4 text-base text-[#A1A49D] leading-relaxed max-w-md">
            Ob kurze Frage oder großes Vorhaben: Rufen Sie an, schreiben Sie eine E-Mail
            oder nutzen Sie direkt unser Buchungsformular.
          </p>
          <a
            href="#termin"
            data-testid="contact-cta-booking"
            className="mt-8 inline-block bg-[#C89D66] hover:bg-[#b8894f] text-[#1A1C19] font-bold px-8 py-4 rounded-full transition-colors text-sm sm:text-base"
          >
            Zum Buchungsformular
          </a>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="grid grid-cols-1 sm:grid-cols-2 gap-4"
        >
          {ITEMS.map(({ icon: Icon, label, value, href, testId }) => {
            const inner = (
              <>
                <Icon className="w-5 h-5 text-[#C89D66]" />
                <div className="mt-4">
                  <p className="text-xs font-semibold uppercase tracking-widest text-[#A1A49D]">{label}</p>
                  <p className="text-sm sm:text-base font-semibold text-white mt-1.5 break-words">{value}</p>
                </div>
              </>
            );
            const cls =
              "bg-[#1E211E] border border-[#323632] rounded-2xl p-6 hover:border-[#C89D66]/50 transition-colors";
            return href ? (
              <a key={label} href={href} data-testid={testId} className={cls}>
                {inner}
              </a>
            ) : (
              <div key={label} data-testid={testId} className={cls}>
                {inner}
              </div>
            );
          })}
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.25 }}
          className="lg:col-span-2 mt-4 rounded-2xl overflow-hidden border border-[#323632]"
          data-testid="contact-map-card"
        >
          <iframe
            title="Anfahrt – LLP Zaun&Garten, Hummelbecker Str. 18, 32429 Minden"
            src="https://www.openstreetmap.org/export/embed.html?bbox=8.8600%2C52.2500%2C8.9500%2C52.3000&layer=mapnik&marker=52.2645%2C8.8978"
            className="w-full h-80 border-0"
            loading="lazy"
            data-testid="contact-map-iframe"
          />
          <div className="bg-[#1E211E] px-6 py-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
            <p className="text-sm text-[#A1A49D]">LLP Zaun&Garten · Hummelbecker Str. 18 · 32429 Minden</p>
            <a
              href="https://www.openstreetmap.org/?mlat=52.2645&mlon=8.8978#map=15/52.2645/8.8978"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-map-link"
              className="text-sm font-semibold text-[#C89D66] hover:text-white transition-colors"
            >
              Größere Karte anzeigen
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
